import { render, staticRenderFns } from "./task_list_item_actions.vue?vue&type=template&id=a03276f6&"
import script from "./task_list_item_actions.vue?vue&type=script&lang=js&"
export * from "./task_list_item_actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports